const INTERNAL_OWNER_EMAIL_LABELS: Record<string, string> = {
  'wd@linfinityeng.com': 'WD',
  'wd@eqeng.com.au': 'WD',
  'wdu@eqeng.com.au': 'WD',
  'yl@linfinityeng.com': 'YL',
  'jp@linfinityeng.com': 'JP',
};

export function userEmailToUserInitial(value?: string | null): string | null {
  const normalized = String(value || '').trim().toLowerCase();
  return INTERNAL_OWNER_EMAIL_LABELS[normalized] || null;
}

export function replaceInternalOwnerEmails(value?: string | null): string {
  const text = String(value || '').trim();
  if (!text) return '';

  let normalized = text;
  for (const [email, label] of Object.entries(INTERNAL_OWNER_EMAIL_LABELS)) {
    const escapedEmail = email.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    normalized = normalized.replace(new RegExp(escapedEmail, 'gi'), label);
  }

  return normalized;
}

export const replaceInternalUserEmails = replaceInternalOwnerEmails;
export const summarizeInternalOwner = userEmailToUserInitial;
